import { Col, Form, Row } from 'antd';
import Modal from 'antd/lib/modal/Modal';
import Button from './Button';
import Title from 'antd/es/skeleton/Title';
import { InfoCircleFilled, InfoCircleOutlined } from '@ant-design/icons';

interface IProps {
  title: string;
  description: string;
  isVisible: boolean;
  onlyOK?: boolean;
  onCancel?: () => void;
  onOk: () => void;
}

const PopupConfirmBase = (props: IProps): JSX.Element => {
  const { title, description, isVisible, onlyOK, onCancel, onOk } = props;
  return (
    <Modal open={isVisible} footer={null} width={'500px'} closeIcon={false}>
      <Col>
        <InfoCircleOutlined
          style={{
            display: 'block',
            marginTop: '10px',
            textAlign: 'center',
            fontSize: '34px',
          }}
        />
        <p
          style={{
            textAlign: 'center',
            fontWeight: 'bold',
            marginBottom: '20px',
            marginTop: '20px',
            fontSize: '24px',
          }}
        >
          {title}
        </p>
        <p
          style={{
            textAlign: 'center',
            marginBottom: '40px',
            fontSize: '16px',
          }}
        >
          {description}
        </p>
      </Col>
      <Row justify="end">
        <Col className="flex justify-end">
          {!onlyOK && (
            <Form.Item className="mr-2">
              <Button
                bgColor={'bg-white'}
                color={'text-primary-50'}
                border={'border-primary-50'}
                customClass="fix-border-radius"
                onClick={onCancel}
              >
                Hủy
              </Button>
            </Form.Item>
          )}
          <Form.Item>
            <Button key="ok" onClick={onOk}>
              Đồng ý
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Modal>
  );
};

export default PopupConfirmBase;
